// extracted by mini-css-extract-plugin
module.exports = {"input":"_1lduZjPo4kKFuE_K37D8bv"};